
import { Component, Vue, Watch } from 'vue-property-decorator'
import SearchField from './SearchField.vue'
import {perPageOptions} from '@/constants/ListOptions'

@Component({
  components: { SearchField }
})
export default class Lists extends Vue {
  datas = []
  isPaginated = false
  total = 0
  page = 1

  sortField = ''
  sortOrder = false

  defaultSortOrder = false
  dataType = ''

  totalPages = 0
  currentPage = 1
  totalResults = 0

  perPageOptions = perPageOptions
  perPage: number = Number(localStorage.getItem('resultsPerListPage')) || this.perPageOptions[0]
  ordersPerPage = 10
  ordersTotalResults = 0
  plotsTotalResults = 0
  accessesTotalResults = 0

  changePage (page) {
    this.currentPage = page
    this.$urlManager.setUrlParameter('page', page.toString())
  }

  async onSort(field, order) {
    this.sortField = field
    order === "asc" ? this.sortOrder = false : this.sortOrder = true
    this.fetchData()
  }

  async deleteRow(id, password, dataType) {
    try {
      this.deleteData(id, password, this.dataType)
    } catch (e) {
      // this.checkError(this, e)
    }
  }

  mounted() {
    this.$urlManager.registerUrlParameter('page', () => {
      this.currentPage = Number(this.$urlManager.getUrlParameter('page')) || 1
    })
    this.currentPage = Number(this.$urlManager.getUrlParameter('page')) || 1
  }
  beforeDestroy() {
    this.$urlManager.deleteUrlParameter('page')
  }
  @Watch('perPage')
  perPageChanged() {
    localStorage.setItem('resultsPerListPage', this.perPage.toString())
  }

  fetchData(): any {
    return null
  }
  deleteData(id, password, dataType): any {
    return null
  }
}
